var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.38162,
    y: 0.9866,
    width: 12.0268,
    height: 12.0268,
    rx: 6.01338,
    stroke: "#171D39",
    strokeWidth: 0.76324
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 9.39498L8.79 4.60498M8.79 4.60498H4.479M8.79 4.60498V8.91598",
    stroke: "#171D39",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightTop);
export default __webpack_public_path__ + "static/media/arrow_right_top.23b6d78d7ef966e2ed6eadb06391c78e.svg";
export { ForwardRef as ReactComponent };